import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import SvgIcon from "./SvgIcon";
/**
 * 
 * options is an array like this: 
 * [
    {
      text:'',
      value:...
    },
    {
      text:'',
      value:...
    },
    ...
 * ]
 */
const DropdownFocus = ({
  summaryText,
  options,
  onSelectFn,
  fullOption,
  alignRight,
  disabled,
}) => {
  const [opened, setOpened] = useState(false);
  const selectedRef = useRef(null); //reference to the selected item
  const handleClick = (e) => {
    e.preventDefault();
    setOpened(!opened);
  };

  //scroll to the selected item when the component is opened
  useEffect(() => {
    if (opened && selectedRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: "auto",
        block: "nearest",
      });
    }
  }, [opened]);

  return (
    <details
      role="list"
      className={disabled ? "disabled" : ""}
      open
      data-align-right={alignRight ? true : undefined}
    >
      <summary
        onClick={(e) => !disabled && handleClick(e)}
        onBlur={(e) => {
          e.preventDefault();
          setOpened(false);
        }}
        aria-haspopup="listbox"
      >
        <p>{summaryText}</p>
        <SvgIcon
          src={opened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </summary>
      <ul role="listbox" className={opened ? "opened" : ""}>
        {options?.map((option, i) => {
          const isSelected =
            option.value === summaryText || option.text === summaryText;

          return (
            <li
              key={i}
              onMouseDown={() => onSelectFn(fullOption ? option : option.value)}
              ref={isSelected ? selectedRef : null} //Actual item
            >
              <div>{option.text || option.label}</div>
            </li>
          );
        })}
      </ul>
    </details>
  );
};
DropdownFocus.propTypes = {
  summaryText: PropTypes.string,
  options: PropTypes.array,
  onSelectFn: PropTypes.func,
  fullOption: PropTypes.bool,
  alignRight: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DropdownFocus;
